import { render } from "./Holidays.vue?vue&type=template&id=d155f506"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"

import "./Holidays.vue?vue&type=style&index=0&id=d155f506&lang=scss"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__